/**
 * A list of product sorting options.
 * @type {Array<{id: string, name: string}>}
 * @property {string} id - The filter id.
 * @property {string} name - The i18n key for the sorting option name.
 */
export const PRODUCT_SORTING_LIST = [
  { id: "", name: "Featured" },
  { id: "name-ascending", name: "Alphabetically, A-Z" },
  { id: "name-descending", name: "Alphabetically, Z-A" },
  { id: "price-ascending", name: "Price, low to high" },
  { id: "price-descending", name: "Price, high to low" },
  { id: "createddate-descending", name: "Date, new to old" },
  { id: "createddate-ascending", name: "Date, old to new" },

  // Innovadis custom filters
  { id: "popular", name: "Popularity" },
  { id: "most-bought", name: "Most bought" },
];
